import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Change,
  Reset,
} from "../../../store/async-actions/digitalmarketing/header";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import DashTable from "./DashTable";
import Tabs from "../../../Component/DigitalMarketing/Tabs";
import { Button } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import { BsBoxArrowRight } from "react-icons/bs";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import DateRangePicker from "../../../Component/DigitalMarketing/Forms/DateRangePicker";
import Dropdown from "../../../Component/DigitalMarketing/Forms/Dropdown";
import {
  useGetReportinExcelMutation,
  useGetReportsListQuery,
} from "../../../Service/reports";
import moment from "moment";
import { useGetDashboardStatusesQuery } from "../../../Service/dashboard";
import { Source } from "./Utils/TableHeadlist";
import { saveAs } from "file-saver";
import { FiFilter } from "react-icons/fi";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import TipList from "./TipList";
import CategoryList from "./CategoryList";
import { useGetWellnessCategoryListQuery, useGetWellnessCategoryQuery } from "../../../Service/wellnessTips";
import Loader from "../../../Component/DigitalMarketing/Loader";

function WellnessTips() {
  const [pagination, setpagination] = useState(1);
  const initialstate = {
    startDate: null,
    endDate: null,
  };
  const [date, setDate] = useState(initialstate);
  const [dateRange, setDateRange] = useState(initialstate);
  const [submit, setsubmit] = useState(false);
  const { open: open1, message, openSnackBar, type } = useSnackbar();
  const [active, setActive] = useState(1);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch<any>();
  const [searchValue, setSearchValue] = useState("");
  const [show, setShow] = useState(false);
  const [paramsValue, setParamsValue] = useState({
    date: initialstate,
    source: "",
  });
  const [source, setSource] = useState("");
  const [getReportinExcel] = useGetReportinExcelMutation();
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setsubmit(false);
  };
  const { data: category,refetch:refetchdata }: any = useGetWellnessCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });

  

  const activeCategories = category && category.filter(category => category.activeStatus === 1);

  const Option_list = {
    category: activeCategories,
  };
  // console.log(activeCategories);
  
  useEffect(() => {
    refetchdata();
    setOpen(false);
  }, [active]);
  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };
  const pagi = {
    pageNo: pagination,
    date: paramsValue?.date,
    source: paramsValue?.source,
    name: searchValue,
  };
  const { data: categorylist,isLoading,refetch:refetchlist }: any = useGetWellnessCategoryListQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  // console.log(categorylist);
  useEffect(() => {
    setpagination(1);
  }, [searchValue]);

  useEffect(() => {
    dispatch(Reset());
  }, [dispatch]);
  // const ListFilter = () => {
  //   if (
  //     !date?.startDate ||
  //     date?.startDate === "Invalid date" ||
  //     date?.endDate !== "Invalid date"
  //   ) {
  //     setParamsValue({
  //       date,
  //       source,
  //     });
  //     setShow(true);
  //     setpagination(1);
  //   } else {
  //     openSnackBar("Please select end date!", "error");
  //   }
  // };
  useEffect(() => {
    const data: any = {
      first: "Wellness Tips",
    };
    dispatch(Change(data));
  }, [dispatch]);
  const values = [
    { id: 1, name: "Tips List" },
    { id: 2, name: "Category List" },
  ];
  const onHandleChange = (event) => {
    const { name, value } = event.target;
    if (name === "date") {
      setDate({
        startDate: moment(value[0]).format("YYYY-MM-DD"),
        endDate: moment(value[1]).format("YYYY-MM-DD"),
      });
      setDateRange(value);
    } else if (name === "source") {
      setSource(value);
    }
  };

  const ClearFilter = () => {
    setShow(false);
    setDate(initialstate);
    setDateRange(initialstate);
    setParamsValue({ date: initialstate, source: "" });
    setSource("");
    setSearchValue("");
  };
  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <React.Fragment>
      <div>
        <Toast open={open1} type={type} message={message} />
        <Row className="mb-3">
          <Col md={5} className="mb-3">
            <SearchBox
              value={searchValue}
              onChange={(event) => onChangeSearch(event)}
            />
          </Col>
          {active === 1 && (
            <Col md={7} className="d-flex mb-3 justify-content-between">
              {/* <DateRangePicker
                DisableFutureDate={true}
                date={dateRange}
                key_name="date"
                handleChange={onHandleChange}
              />{" "}
              &nbsp;&nbsp; */}
              <Dropdown
                option={activeCategories}
                ids="categoryName"
                source={source}
                defaults="Choose category..."
                list_name="categoryName"
                key_name="source"
                handleChange={onHandleChange}
              />
                <div className="filter f-14 mx-2 cursor">
                  <Button variant="contained" id="btn-add">
                    {" "}
                    <FiFilter />
                    &nbsp; Filter
                  </Button>
                </div>
                          {show && (

                <p
                  className="clear-filter f-14 mb-0 mt-1 mx-2 cursor"
                  onClick={ClearFilter}
                >
                  X Clear filters
                </p>
              )}
            </Col>
          )}
        </Row>
        <Row className="">
          <Col md={8}>
            <Tabs tablist={values} active={active} setActive={setActive} />
          </Col>
          <Col md={4}>
            {active === 1 ? (
              <Button
                className="right mb-2"
                variant="contained"
                onClick={handleOpen}
                id="btn-add"
              >
                + New Wellness Tips
              </Button>
            ) : (
              <Button
                className="right mb-2"
                variant="contained"
                onClick={handleOpen}
                id="btn-add"
              >
                + New Category
              </Button>
            )}
          </Col>
        </Row>
        {active === 1 ? (
          <TipList
            setpagination={setpagination}
            pagination={pagination}
            pagi={pagi}
            open={open}
            setsubmit={setsubmit}
            submit={submit}
            Option_list={Option_list}
            handleOpen={handleOpen}
            handleClose={handleClose}
          />
        ) : (<>
          <CategoryList
            setpagination={setpagination}
            pagination={pagination}
            refetch1={refetchlist}
            open={open}
            setOpen={setOpen}
            pagi={pagi}
            setsubmit={setsubmit}
            submit={submit}
            handleClose={handleClose}
          />
           {!isLoading &&<Pagination
          setpagination={setpagination}
          pagination={pagination}
          data={categorylist}
        />}</>
        )}
      </div>
    </React.Fragment>
  );
}

export default React.memo(WellnessTips);
